import {canUseStocktakeSelector} from '../../data/stocktakes.js'
import {useSelector} from '../../store.js'
import {showAddToStocktakeModal} from '../StocktakeListPage/Modals/AddToStocktakeModal.js'
import {showCreateStocktakeModal} from '../StocktakeListPage/Modals/CreateStocktakeModal.js'
import {showRemoveFromStocktakeModal} from '../StocktakeListPage/Modals/RemoveFromStocktakeModal.js'
import {
  countSelector,
  productListQueryParamsSelector,
} from './productListFunctions.js'

export default function StocktakeActions({skus = []}) {
  const canUseStocktake = useSelector(canUseStocktakeSelector)

  const productListQueryParams = useSelector(productListQueryParamsSelector)
  const productListCount = useSelector(countSelector)

  if (!canUseStocktake) {
    return null
  }

  return (
    <>
      <li className="list__item list__item--dropdown list__item--dropdown-header">
        <strong>STOCKTAKE ACTIONS</strong>
      </li>
      <li className="list__item list__item--dropdown">
        <button
          className="btn--link list__link--dropdown"
          type="button"
          onClick={() => showCreateStocktakeModal({skus})}
        >
          {skus.length === 0
            ? 'Create a New Stocktake'
            : 'Add All Selected Products to a New Stocktake'}
        </button>
      </li>
      {skus.length === 0 ? (
        <>
          <li className="list__item list__item--dropdown">
            <button
              className="btn--link list__link--dropdown"
              type="button"
              onClick={() =>
                showCreateStocktakeModal({
                  productListQueryParams,
                  productListCount,
                })
              }
            >
              Add All Filtered Products ({productListCount}) to a New Stocktake
            </button>
          </li>
          <li className="list__item list__item--dropdown">
            <button
              className="btn--link list__link--dropdown"
              type="button"
              onClick={() =>
                showAddToStocktakeModal({
                  productListQueryParams,
                  productListCount,
                })
              }
            >
              Add All Filtered Products ({productListCount}) to an Existing
              Stocktake
            </button>
          </li>
        </>
      ) : (
        <>
          <li className="list__item list__item--dropdown">
            <button
              className="btn--link list__link--dropdown"
              type="button"
              onClick={() => showAddToStocktakeModal({skus})}
            >
              Add All Selected Products to an Existing Stocktake
            </button>
          </li>
          <li className="list__item list__item--dropdown">
            <button
              className="btn--link list__link--dropdown"
              type="button"
              onClick={() => showRemoveFromStocktakeModal(skus)}
            >
              Remove from Stocktake
            </button>
          </li>
        </>
      )}
    </>
  )
}
